import { TagGroupApiModel } from '../../../api/tags/tag-group-api.model';

export class TagGroupModel {
    createdByUserId?: number;
    createdDate?: number;
    id?: number;
    lastModifiedByUserId?: number;
    lastModifiedDate?: number;
    name: string;
    tagIds: number[] = [];

    constructor(apiModel?: TagGroupApiModel) {
        if (apiModel) {
            this.createdByUserId = apiModel.createdByUserId;
            this.createdDate = apiModel.createdDate;
            this.id = apiModel.id;
            this.lastModifiedByUserId = apiModel.lastModifiedByUserId;
            this.lastModifiedDate = apiModel.lastModifiedDate;
            this.name = apiModel.name;
            this.tagIds = apiModel.tagIds;
        }
    }

    public toApiModel(): TagGroupApiModel {
        return {
            id: this.id,
            name: this.name,
            tagIds: this.tagIds
        };
    }
}
